import { render } from "./HistoryFooter.vue?vue&type=template&id=5aa29f0f&scoped=true"
import script from "./HistoryFooter.vue?vue&type=script&lang=js"
export * from "./HistoryFooter.vue?vue&type=script&lang=js"

import "./HistoryFooter.vue?vue&type=style&index=0&id=5aa29f0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa29f0f"]])

export default __exports__